export const goTo = (selector: string) => {
  document.querySelector(selector)?.scrollIntoView({
    behavior: "smooth",
  });
};

export const formatNumber = (value: string | number) => {
  const rawValue = String(value).trim();
  const normalizedValue = rawValue.replace(/\s+/g, "").replace(",", ".");
  const parsedValue = Number(normalizedValue);

  if (Number.isFinite(parsedValue)) {
    return parsedValue.toLocaleString("ru-RU");
  }

  return rawValue;
};
